import React, { Fragment } from "react";
import ContentsBody from "./ContentsBody";
import Header from "../../../../components/UI/Header/Header";
import styled from "styled-components";

export default (props) => {
  return (
    <Fragment>
      <Header rightClickEvent={props.rightClickEvent} />
      <ContentsBody>비대면진료 시범사업 지침에 따른 섬·벽지 및 의료취약지</ContentsBody>

      {/* 섬 벽지 */}
      <InnerContentsBodyDiv>
        <PurpleTextDiv>섬·벽지</PurpleTextDiv>

        <CssTable>
          <colgroup>
            <col width="20%" />
            <col width="40%" />
            <col width="40%" />
          </colgroup>

          <thead>
            <tr>
              <GrayTd textAlign="center" verticalAlign="top" scope="col">
                구분
              </GrayTd>
              <GrayTd scope="col">읍면동</GrayTd>
              <GrayTd scope="col">경감지역(섬)</GrayTd>
            </tr>
          </thead>
          <tbody>
            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                인천
              </GrayTd>
              <WhiteTd verticalAlign="top">원창동, 무의동</WhiteTd>
              <WhiteTd verticalAlign="top">세어도, 팔미도</WhiteTd>
            </tr>

            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                경기
              </GrayTd>
              <WhiteTd verticalAlign="top">풍도동, 우정읍</WhiteTd>
              <WhiteTd verticalAlign="top">풍도, 육도, 국화도, 입파도</WhiteTd>
            </tr>

            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                전북
              </GrayTd>
              <WhiteTd verticalAlign="top">옥도면</WhiteTd>
              <WhiteTd verticalAlign="top">개야도, 연도, 어청도</WhiteTd>
            </tr>

            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                전남
              </GrayTd>
              <WhiteTd verticalAlign="top">
                달동, 율도동, 화정면, 남면, 삼산면, 율촌면, 화양면, 월호동, 시전동, 삼일동, 돌산읍
              </WhiteTd>
              <WhiteTd verticalAlign="top">
                달리도, 외달도, 율도, 월호도, 자봉도, 개도, 제도, 상화도, 하화도, 사도, 추도,
                여자도, 송여자도, 금오도, 수향도, 안도, 부도, 대두라도, 소두라도, 나발도, 대횡간도,
                소횡간도, 연도, 거문도, 서도, 동도, 초도, 손죽도, 소거문도, 평도, 광도, 송도,
                대늑도, 소늑도, 운두도, 대경도, 소경도, 야도, 장도, 삼간도
              </WhiteTd>
            </tr>

            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                경남
              </GrayTd>
              <WhiteTd verticalAlign="top">구산면, 진동면,웅천동, 태평동</WhiteTd>
              <WhiteTd verticalAlign="top">
                귀곡큰닭섬, 실리도, 양도, 송도, 수우도, 연도, 우도, 잠도
              </WhiteTd>
            </tr>

            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                제주
              </GrayTd>
              <WhiteTd verticalAlign="top">추자면, 한림읍,우도면</WhiteTd>
              <WhiteTd verticalAlign="top">황간도, 추포도, 추자도, 비양도, 우도</WhiteTd>
            </tr>
          </tbody>
        </CssTable>
      </InnerContentsBodyDiv>

      {/* 의료 취약지 */}
      <InnerContentsBodyDiv style={{ marginTop: "40px", paddingBottom: "40px" }}>
        <PurpleTextDiv>의료취약지</PurpleTextDiv>

        <CssTable>
          <colgroup>
            <col width="20%" />
            <col width="80%" />
          </colgroup>
          <thead>
            <tr>
              <GrayTd textAlign="center" verticalAlign="top" scope="col">
                구분
              </GrayTd>
              <GrayTd scope="col">읍면동</GrayTd>
            </tr>
          </thead>

          <tbody>
            <tr>
              <GrayTd textAlign="center" verticalAlign="top">
                인천
              </GrayTd>
              <WhiteTd verticalAlign="top">원창동, 무의동</WhiteTd>
            </tr>

            {medicalWeekArr.map((m, i) => (
              <tr>
                <GrayTd textAlign="center" verticalAlign="top">
                  {m.location}
                </GrayTd>
                <WhiteTd verticalAlign="top">{m.locationDetail}</WhiteTd>
              </tr>
            ))}
          </tbody>
        </CssTable>
      </InnerContentsBodyDiv>
    </Fragment>
  );
};

const medicalWeekArr = [
  {
    location: "인천",
    locationDetail: "강화군, 옹진군",
  },
  {
    location: "경기",
    locationDetail: "가평군, 동두천시, 양평군, 여주시, 연천군",
  },
  {
    location: "강원",
    locationDetail:
      "고성군, 동해시, 삼척시, 속초시, 양구군, 양양군, 영월군, 인제군, 정성군, 철원군, 태백시, 평창군, 홍천군, 화천군, 횡성군",
  },
  {
    location: "충북",
    locationDetail: "괴산군, 단양군, 보은군, 영동군, 옥천군, 음성군, 진천군, 충주시",
  },
  {
    location: "충남",
    locationDetail:
      "공주시, 금산군, 당진시, 보령시, 부여군, 서산시, 서천구느 예산군, 청양군, 태안군, 홍성군",
  },
  {
    location: "전북",
    locationDetail: "고창군, 남원시, 무주군, 부안군, 순창군, 임실군, 장수군, 정읍시, 진안군",
  },
  {
    location: "전남",
    locationDetail:
      "강진군, 고흥군, 곡성군, 구례군, 나주시, 담양군, 무안군, 보성군, 신안군, 영광군, 영암군, 완도군, 장성군, 장흥군, 진도군, 함평군, 해남군",
  },
  {
    location: "대구",
    locationDetail: "군위군",
  },
  {
    location: "경북",
    locationDetail:
      "고령군, 문경시, 봉화군, 상주시, 성주군, 영덕군, 영주시, 영양군, 영천시, 예천군, 울른군, 울진군, 의성군, 청도군, 청송군",
  },
  {
    location: "경남",
    locationDetail:
      "거제시, 거창군, 고성군, 남해군, 밀양시, 사천시, 산청군, 의령군, 창년군, 하동군, 함안군, 함양군, 합천군",
  },
  {
    location: "제주",
    locationDetail: "서귀포시",
  },
];

const TitleDiv = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 133.333% */
`;

const InnerContentsBodyDiv = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const PurpleTextDiv = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: rgba(107, 101, 222, 0.1);
  color: #6b65de;
`;

const CssTable = styled.table`
  border-collapse: collapse;
`;

const GrayTd = styled.td`
  width: 96px;
  padding: 8px 12px;
  align-items: flex-start;
  align-self: stretch;
  background-color: #f5f5f5;
  text-align: ${(props) => props.textAlign};
  vertical-align: ${(props) => props.verticalAlign};
  border: 0.5px solid #ddd;

  color: #333;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
`;

const WhiteTd = styled.td`
  width: 96px;
  padding: 8px 12px;
  align-items: flex-start;
  align-self: stretch;
  vertical-align: ${(props) => props.verticalAlign};
  border: 0.5px solid #ddd;

  color: #666;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`;
